import React, { Component } from "react";
import * as R from "ramda";
import { getConfigSales } from "./config";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import {HttpStatus} from "../../../../common/Constants";
import {fetchDataAsync} from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";

class SalesReportBy extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableConfig: [],
            dataTable: [],
        };
    };

    componentDidMount() {
        this.setState((prevValue) => ({
            ...prevValue,
            tableConfig: getConfigSales(this.props.tab),
        }));
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!R.equals(prevProps.doSearch, this.props.doSearch) && this.props.doSearch === true) {
            this.fetchData(this.props.search);
            this.props.onSearchValueChange("doSearch", false);
        }
    };

    fetchData = async (payload) => {
        let res = {};
        let { tab } = this.props;
        this.props.triggerLoading();

        if (R.equals(tab, "type")) {
            res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanPenjualanPerTypeKacab,
                menuName: "Dashboard Kacab - Laporan Jualan Per Type Per Team Leader - Laporan Jualan Per Tipe",
                setError: this.props.setError,
                args: payload,
            });
        }
        if (R.equals(tab, "series")) {
            res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanPenjualanPerSeriesKacab,
                menuName: "Dashboard Kacab - Laporan Jualan Per Type Per Team Leader - Laporan Jualan Per Series",
                setError: this.props.setError,
                args: payload,
            });
        }
        if (R.equals(tab, "subSegment")) {
            res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanPenjualanPerSubSegmentKacab,
                menuName: "Dashboard Kacab - Laporan Jualan Per Type Per Team Leader - Laporan Jualan Per Sub Segmen",
                setError: this.props.setError,
                args: payload,
            });
        }

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: res.data.data || []
            }));
        }
        this.props.triggerLoading();
    };

    render() {
        return (
            <>
                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.state.tableConfig}
                    // toCount={0}
                    // rowsPerPage={10}
                    // page={0}
                    options={{pagination: false, serverSide: false}}
                />
            </>
        );
    };
}

export default SalesReportBy;